import { render, staticRenderFns } from "./RulesForm.vue?vue&type=template&id=240a657c&scoped=true&"
import script from "./RulesForm.vue?vue&type=script&lang=js&"
export * from "./RulesForm.vue?vue&type=script&lang=js&"
import style0 from "./RulesForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RulesForm.vue?vue&type=style&index=1&id=240a657c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a657c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow,VSelect,VTextField})
